import { Level, LevelName } from './level';
import { ThemeName } from '../themes/theme';
import { PassengerIcon } from '../Passenger';
import { PassengerSprite } from '../Passenger';
import { ObstacleName } from '../entities/obstacle/Obstacle';

export const level2: Level = {
  id: LevelName.Level2,
  theme: ThemeName.Park,
  laneItemDetails: {
    minLanesAtOnce: 1,
    maxLanesAtOnce: 1,
    antiRepeatSpawnDistance: 500,
    minSpawnAheadDistance: 1000,
    maxSpawnAheadDistance: 2000,
    defaultMaxSpawned: 1,
    defaultTimeBetweenSpawns: 12000,
    allowedObstacles: [ObstacleName.ObstacleBoxes, ObstacleName.ObstacleMudPatch, ObstacleName.ObstacleBananaSkin, ObstacleName.ObstacleOilSlick, ObstacleName.ObstacleLeafPile],
    obstacleConfiguration: {
      [ObstacleName.ObstacleBananaSkin]: { maxSpawned: 1, timeBetweenSpawns: 5000 }
    },
    boostConfiguration: { maxSpawned: 2, timeBetweenSpawns: 5000 }
  },
  trafficDetails: {
    maxVehicles: 0,
    minTimeBetweenSpawns: 1000,
    maxTimeBetweenSpawns: 5000,
    minSpawnAheadDistance: 500,
    maxSpawnAheadDistance: 1000,
    maxLanesAtOnce: 2,
    minTimeBetweenSpeedChanges: 4000,
    maxTimeBetweenSpeedChanges: 7000
  },
  taxiDetails: {
    npcTaxis: 1,
    taxis: [
      {
        startLane: 3,
        startIndentX: 0
      }
    ]
  },
  passengerDetails: {
    defaultPassengerPickupBonus: 150,
    defaultPassengerDropOffBonus: 150,
    defaultPassengerDistanceRate: 2 / 100,
    passengers: [
      {
        sprite: PassengerSprite.Fifteen,
        icon: PassengerIcon.Fifteen,
        pickupDistance: 4000,
        travelDistance: 15000,
        passengerPickupBonus: 15,
        passengerDropOffBonus: 50,
        passengerDistanceRate: 5 / 1000
      }
    ]
  }
};
